import { createApp } from 'vue';
import { createPinia } from 'pinia';
import router from './router';
import App from './App.vue';
import { configureTokenKeys } from '@ct-vision/shared';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/main.css';

// 用户端使用独立的 token 键名，与管理端隔离
configureTokenKeys({
  tokenKey: 'access_token',
  refreshTokenKey: 'refresh_token',
  refreshEndpoint: '/api/user/auth/refresh-token',
});

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.mount('#app');
